import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Signup from 'Components/ModalContent/Signup';
import ResetPassword from 'Components/ModalContent/ResetPassword';
import Login from 'Components/ModalContent/Login';
import FoundItem from 'Components/ModalContent/FoundItem';
import ConfirmItemDelete from 'Components/ModalContent/ConfirmItemDelete';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'Store/actions';

const styles = theme => ({});

const Modal = ({ fullScreen, activeModal, setActiveModal }) => {
  const getModalContents = () => {
    const isDeleteConfirmationModal = activeModal.startsWith('delete-item');
    if (isDeleteConfirmationModal) {
      return <ConfirmItemDelete />;
    }

    switch (activeModal) {
      case 'signup':
        return <Signup />;
      case 'login':
        return <Login />;
      case 'resetPassword':
        return <ResetPassword />;
      case 'foundItem':
        return <FoundItem />;
      default:
        break;
    }
  };

  const onModalClose = () => {
    setActiveModal('none');
  };

  const renderModal = () => {
    return (
      <Dialog
        fullScreen={fullScreen}
        open={activeModal !== 'none'}
        onClose={onModalClose}
      >
        <DialogContent>{getModalContents()}</DialogContent>
      </Dialog>
    );
  };

  return renderModal();
};

function mapStateToProps({ activeModal }) {
  return {
    activeModal,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withMobileDialog()(Modal)));
